export default __webpack_public_path__ + "static/media/signUp.726e5365.png";